// extracted by mini-css-extract-plugin
export default {"featuresContainer":"features_featuresContainer__FZueE","featuresCol":"features_featuresCol__4om1d","featuresCol1":"features_featuresCol1__rFZv8"};